import CryptoJS from "crypto-js";

const encryptionKey = "PERMISSION";

export const defaultPermissions = [
  {
    assignable: false,
    path: "dashboard",
    name: "Dashboard",
    componentName: "Dashboard",
    code: "SUPPORT_PLAN_DASHBOARD",
    childModules: [],
  },
];

export const calendarPermission = [
  {
    assignable: true,
    hide: false,
    path: "calendar-viewer/:usersId",
    name: "Calendar Viewer",
    componentName: "CalendarViewer",
    code: "CALENDAR_VIEWER",
  },
];

export const getAllCodesRecursive2 = (modules) => {
  let codes = modules.map((module) => module.code);
  modules.forEach((module) => {
    if (module.childModules && module.childModules.length > 0) {
      codes = codes.concat(getAllCodesRecursive(module.childModules));
    }
  });
  return codes;
};

export const getAllCodesRecursive = (modules = []) => {
  let codes = [];

  for (const mod of modules) {
    if (mod.code) {
      codes.push(mod.code);
    }

    if (Array.isArray(mod.childModules) && mod.childModules.length > 0) {
      codes = codes.concat(getAllCodesRecursive(mod.childModules));
    }
  }

  return codes;
};

export const filterRoutes2 = (routes, allowedCodes) => {
  return routes.reduce((filteredRoutes, route) => {
    const filteredRoute = { ...route };

    if (route.childModules && route.childModules.length > 0) {
      filteredRoute.childModules = filterRoutes(
        route.childModules,
        allowedCodes,
      );
      if (filteredRoute.childModules.length > 0) {
        filteredRoutes.push(filteredRoute);
      }
    } else if (allowedCodes.includes(route.code)) {
      filteredRoutes.push(filteredRoute);
    }

    return filteredRoutes;
  }, []);
};

export const filterRoutes = (routes, allowedCodes) => {
  return routes.reduce((filteredRoutes, route) => {
    const filteredRoute = { ...route };
    if (Array.isArray(route.childModules) && route.childModules.length > 0) {
      filteredRoute.childModules = filterRoutes(
        route.childModules,
        allowedCodes,
      );
    } else {
      filteredRoute.childModules = [];
    }
    if (
      allowedCodes.includes(filteredRoute.code) ||
      filteredRoute.childModules.length > 0
    ) {
      filteredRoutes.push(filteredRoute);
    }

    return filteredRoutes;
  }, []);
};

export const encryptPermissions = (data) => {
  try {
    const deepCopy = JSON.parse(JSON.stringify(data));
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(deepCopy),
      encryptionKey,
    );
    localStorage.setItem("permissions", encrypted.toString());
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

export const decryptPermissions = () => {
  try {
    if (localStorage.getItem("permissions")) {
      const encryptedData = localStorage.getItem("permissions");
      const decrypted = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedText);
    } else {
      return [];
    }
  } catch (error) {
    console.error("Decryption error:", error);
  }
};

export const isPermissionExists = () => {
  return localStorage.getItem("permissions");
};

export const flatRoutes = (array) => {
  let result = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.childModules)) {
      result = result.concat(flatRoutes(a.childModules));
    }
  });
  return result.map((module) => {
    return {
      moduleName: module.moduleName,
      code: module.code,
      parentCode: module.parentCode,
    };
  });
};

export const transformRoutes = (inputModules, parentCode = null) => {
  return inputModules.map((module) => {
    const { name, code, childModules } = module;
    const transformedModule = {
      moduleName: name,
      code,
      parentCode,
    };

    if (childModules && childModules.length > 0) {
      transformedModule.childModules = transformRoutes(childModules, code);
    }

    return transformedModule;
  });
};

export const doesCodeExist = (searchCode, routes) => {
  for (const route of routes) {
    if (route.code === searchCode) {
      return true;
    }
    if (route.childModules && route.childModules.length > 0) {
      if (doesCodeExist(searchCode, route.childModules)) {
        return true;
      }
    }
  }
  return false;
};
